import { EmptyStateImageSrc, EmptyStateTasks } from '../components/partials/EmptyState/utils';

export const shouldShowEmptyState = ({ tasks }) => {
    return !(tasks[EmptyStateTasks.AUDIENCE_SEGMENT_CREATED] && tasks[EmptyStateTasks.AUDIENCE_DISTRIBUTION_CREATED]);
};

const getEmptyStateTasks = tasks => {
    const completed = [];
    if (!tasks[EmptyStateTasks.AUDIENCE_SEGMENT_CREATED]) {
        completed.push({
            topic: EmptyStateTasks.AUDIENCE_SEGMENT_CREATED,
            name: 'STATIC.PAGES.AUDIENCES.AUDIENCE_AB_TESTING.EMPTY_STATE.CREATE_SEGMENT',
            actionText: 'STATIC.PAGES.AUDIENCES.AUDIENCE_AB_TESTING.EMPTY_STATE.ACTION_BUTTONS.CREATE_NOW',
            goRedirect: '#/react/audiences/segments',
        });
    }

    if (!tasks[EmptyStateTasks.AUDIENCE_DISTRIBUTION_CREATED]) {
        completed.push({
            topic: EmptyStateTasks.AUDIENCE_DISTRIBUTION_CREATED,
            name: 'STATIC.PAGES.AUDIENCES.AUDIENCE_AB_TESTING.EMPTY_STATE.TEST_CHANNEL_CONNECT',
            actionText: 'STATIC.PAGES.AUDIENCES.AUDIENCE_AB_TESTING.EMPTY_STATE.ACTION_BUTTONS.CONNECT_NOW',
            goRedirect: '#/react/audiences/distributions',
        });
    }
    return completed;
};

export const getAbTestingEmptyStateData = ({ tasks }) => ({
    titleText: 'STATIC.PAGES.AUDIENCES.AUDIENCE_AB_TESTING.EMPTY_STATE.TITLE',
    subTitleText: 'STATIC.PAGES.AUDIENCES.AUDIENCE_AB_TESTING.EMPTY_STATE.SUBTITLE_STEPS',
    imageSrc: EmptyStateImageSrc.SINGULAR_DUDE,
    tasks: getEmptyStateTasks(tasks),
});
